import { Record } from 'immutable';

import type { JSX } from 'react';

export const mkNotificationDialogProps: Record.Factory<{
  title: string;
  content: string | JSX.Element;
  buttonLabel: string | null;
  onClose: null;
  size: string | null;
  dialogProps: null | {
    disableBackdropClick: boolean;
    disableEscapeKeyDown: boolean;
  };
}> = Record({
  title: 'Notification',
  content: '',
  buttonLabel: 'Okay',
  onClose: null,
  size: null,

  dialogProps: null,
});

export const DIALOG_TYPE = 'DIALOG_NOTIFICATION';
